import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ChevronRight, User, Users } from 'lucide-react';
import { Button } from '../../Button';
import { MobileHeader } from '../MobileHeader';
import { MobileInfoRow } from '../MobileInfoRow';
import { VerifyStepper } from '../VerifyStepper';
import { cngs } from '../../../data/cngs';
import { images } from '../../../data/images';
import type { MobileNav } from '../../../types/mobile';
export function ResultScreen({
  nav
}: {
  nav: MobileNav;
}) {
  const cng = cngs[0];
  return <div className="flex h-full flex-col bg-slate-50" data-id="element-525" data-mp="crslqxethpci">
      <MobileHeader title="যাচাইয়ের ফলাফল" subtitle={`QR ID: ${cng.qrId}`} onBack={() => nav.reset('home')} data-id="element-526" data-mp="8ow7fiwb8fed" />
      <VerifyStepper current={0} data-id="element-527" data-mp="3p9kuiuldmsw" />
      <div className="no-scrollbar flex-1 overflow-y-auto pb-4" data-id="element-528" data-mp="3q1jy3nee2nx">
        <motion.div initial={{
        scale: 0.96,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        duration: 0.25
      }} className="mx-4 mt-3 rounded-xl border-2 border-emerald-600 bg-emerald-50 p-4 text-center" role="status" data-id="element-529" data-mp="2tgoaqbiipm9o">
          <CheckCircle2 className="mx-auto h-14 w-14 text-emerald-600" strokeWidth={2.2} data-id="element-530" data-mp="2tgpmg2dydeyl" />
          <p className="mt-1 font-heading text-2xl font-bold text-emerald-700" data-id="element-531" data-mp="2fh7rt6dz77hb">✓ বৈধ সিএনজি</p>
          <p className="mt-1 text-xs leading-relaxed text-emerald-800" data-id="element-532" data-mp="2kf9k8hxakj5g">গাড়িটি ডিএমপি সিস্টেমে নিবন্ধিত এবং তথ্য হালনাগাদ রয়েছে।</p>
        </motion.div>

        <div className="mx-4 mt-3 overflow-hidden rounded-xl border border-border bg-white" data-id="element-533" data-mp="25pk2bb0zc0ih">
          <div className="relative" data-id="element-534" data-mp="2aiwger818owz">
            <img src={images.cng} alt="সিএনজি ঢাকা-থ-১১-১২৩৪ এর ছবি" className="h-40 w-full object-cover" data-id="element-535" data-mp="1wqgksbhgnt63" />
            <span className="absolute bottom-2 left-2 rounded bg-white/95 px-2 py-1 text-sm font-bold text-navy-900 shadow" data-id="element-536" data-mp="20ra935ytf9zi">{cng.reg}</span>
          </div>
          <div className="px-4 pb-2 pt-3" data-id="element-537" data-mp="1mssnbdsh07k8">
            <h2 className="text-sm font-bold text-navy-900" data-id="element-538" data-mp="1rrn7aj26c25x">সিএনজি তথ্য</h2>
            <dl data-id="element-539" data-mp="1rsydepj3dm07">
              <MobileInfoRow label="রেজিস্ট্রেশন নং" value={cng.reg} data-id="element-540" data-mp="3tg18g36njei0" />
              <MobileInfoRow label="যানের ধরন" value={cng.type} data-id="element-541" data-mp="3ti45h76827w8" />
              <MobileInfoRow label="চেসিস নং" value={cng.chassis} mono data-id="element-542" data-mp="3oorjl4sxgf76" />
              <MobileInfoRow label="ইঞ্জিন নং" value={cng.engine} mono data-id="element-543" data-mp="3kn69tsbowh17" />
              <MobileInfoRow label="BRTA নিবন্ধনের তারিখ" value={cng.brtaRegDate} data-id="element-544" data-mp="3fov1jm11mel3" />
              <MobileInfoRow label="ফিটনেস" value={<span className="text-emerald-700" data-id="element-546" data-mp="ga9ffe63xjsu">✓ বৈধ</span>} data-id="element-545" data-mp="3fn1qzvnb7a7t" />
              <MobileInfoRow label="ফিটনেস মেয়াদ" value={cng.fitnessExpiry} data-id="element-547" data-mp="g7exbtakgb2l" />
              <MobileInfoRow label="ট্যাক্স টোকেন" value={<span className="text-emerald-700" data-id="element-549" data-mp="78t679r13nq7">✓ বৈধ</span>} data-id="element-548" data-mp="c8xmayo0ygfw" />
              <MobileInfoRow label="QR ID" value={`DMP-${cng.qrId}`} mono data-id="element-550" data-mp="7b5x4cerl8fe" />
            </dl>
          </div>
        </div>

        <div className="mx-4 mt-3 grid grid-cols-2 gap-2" data-id="element-551" data-mp="2rzagmxlbx796">
          <button onClick={() => nav.go('owner')} className="flex items-center gap-2 rounded-lg border border-border bg-white p-3 text-left" data-id="element-552" data-mp="2s0v9mirzwi4x">
            <User className="h-5 w-5 text-navy-700" data-id="element-553" data-mp="2cwiqxthk1fn5" />
            <span className="flex-1 text-xs font-semibold text-navy-900" data-id="element-554" data-mp="2cxtw9xqnevgd">মালিকের তথ্য</span>
            <ChevronRight className="h-4 w-4 text-slate-400" data-id="element-555" data-mp="2hw511u236frq" />
          </button>
          <button onClick={() => nav.go('drivers')} className="flex items-center gap-2 rounded-lg border border-border bg-white p-3 text-left" data-id="element-556" data-mp="2mtf266yu8fve">
            <Users className="h-5 w-5 text-navy-700" data-id="element-557" data-mp="2rn9jj3qz0irb" />
            <span className="flex-1 text-xs font-semibold text-navy-900" data-id="element-558" data-mp="2vlqfqs8us8ty">অনুমোদিত চালক (৩)</span>
            <ChevronRight className="h-4 w-4 text-slate-400" data-id="element-559" data-mp="30ktlkewnqj2z" />
          </button>
        </div>
      </div>
      <div className="border-t border-border bg-white p-3" data-id="element-560" data-mp="35lzgmjdsiifo">
        <Button onClick={() => nav.go('owner')} className="h-11 w-full" data-id="element-561" data-mp="3ak1198qv6pt9">পরবর্তী: মালিকের তথ্য দেখুন</Button>
      </div>
    </div>;
}